/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_End_BusyInputs */

const en_us2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine taken: the swap is for today only.`)
};

const pt_br2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparelho ocupado: a troca ficou só para hoje.`)
};

const es_419_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada: el cambio es solo por hoy.`)
};

const pt_pt2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada: a troca ficou só para hoje.`)
};

const fr_fr2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine occupée : le remplacement vaut pour aujourd'hui seulement.`)
};

const de_de2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerät besetzt: Der Tausch gilt nur für heute.`)
};

const it_it2_workout_swap_end_busy = /** @type {(inputs: Workout_Swap_End_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macchina occupata: il cambio vale solo per oggi.`)
};

/**
* | output |
* | --- |
* | "Machine taken: the swap is for today only." |
*
* @param {Workout_Swap_End_BusyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_end_busy = /** @type {((inputs?: Workout_Swap_End_BusyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_End_BusyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_end_busy(inputs)
	if (locale === "es-419") return es_419_workout_swap_end_busy(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_end_busy(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_end_busy(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_end_busy(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_end_busy(inputs)
	return en_us2_workout_swap_end_busy(inputs)
});
export { workout_swap_end_busy as "workout-swap.end_busy" }